import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "RoutePointDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      DFData: [],
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      sortByField: null,
      sortOrder: 'asc',
    };
  },

  methods: {
    getDetail(sortBy = null, sortOrder = null) {
      const params = {
        campus_id: this.$store.state.user.campus_id,
      };
      if (sortBy && sortOrder) {
        params.sort_by = sortBy;
        params.sort_order = sortOrder;
      }
      axios.get(`dailyFerry/detailById/${this.$route.params.id}`, { params })
        .then((res) => {
          if (res.data) {
            this.DFData = res.data.data;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    sortBy(field) {
      if (this.sortByField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortByField = field;
        this.sortOrder = 'asc';
      }
      this.getDetail(this.sortByField, this.sortOrder);
    },
  },

  mounted() {
    this.isLoading = true;
    this.getDetail();
  }
};
